module.exports = __webpack_public_path__ + "static/media/BoD4.5a52d568.JPG";